interface TopBarProps {
  currentIndex: number;
  totalQuestions: number;
  passPercentage: number;
  title?: string;
  subtitle?: string;
}

export default function TopBar({ currentIndex, totalQuestions, passPercentage, title, subtitle }: TopBarProps) {
  const progressPercent = ((currentIndex + 1) / totalQuestions) * 100;

  const resolvedTitle = title || "Final Certification";
  const resolvedSubtitle = (subtitle || "Become a certified First Time People Leader by scoring {passPercentage}% in the below assessment.")
    .replace("{passPercentage}", String(passPercentage));

  return (
    <div className="assess-topbar">
      <div className="assess-title">
        <h1>🎓 {resolvedTitle}</h1>
        <p>{resolvedSubtitle}</p>
      </div>
      <div className="assess-progress-row">
        <div />
        <div className="assess-badge">
          <span className="assess-dot" />
          <span>Question {currentIndex + 1}/{totalQuestions}</span>
        </div>
      </div>
      <div className="assess-progress-track">
        <div
          className="assess-progress-fill"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  );
}
